import { DropdownItem } from 'flowbite-react';
import { HiLockClosed } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

export interface ProductInfo {
    name?: string;
    productName: string;
    isPurchased: boolean;
    metadata?: {
        translation_key?: string;
        [key: string]: string | undefined;
    };
}

interface ProtectedDropdownItemProps {
    productName: string;
    translationKey?: string;
    products: ProductInfo[];
    href?: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

/**
 * A dropdown item that checks if a product is purchased.
 * If not purchased, it displays a lock icon and removes navigation functionality.
 */
const ProtectedDropdownItem: React.FC<ProtectedDropdownItemProps> = ({
    productName,
    translationKey,
    products,
    href,
    onClick,
    children,
}) => {
    // Match by metadata.translation_key (stable, set by us) first, since the raw
    // Stripe product name is editable in the dashboard and not a safe UI identifier.
    // Fall back to productName/name for products without a translation_key.
    const product = translationKey
        ? products.find(p => p.metadata?.translation_key === translationKey)
        : products.find(p => p.productName === productName || p.name === productName);
    const isPurchased = product?.isPurchased ?? false;
    const displayName = product?.name || product?.productName || productName;
    const navigate = useNavigate();

    if (!isPurchased) {
        return (
            <DropdownItem className="cursor-pointer" onClick={() => navigate("/subscriptions")}>
                < div className="flex items-center justify-between w-full" >
                    <span>{children || displayName}</span>
                    <HiLockClosed className="ml-2" size={16} />
                </div >
            </DropdownItem >
        );
    }

    return (
        <DropdownItem href={href} onClick={onClick}>
            {children || displayName}
        </DropdownItem>
    );
};

export default ProtectedDropdownItem;
